import axios from 'axios';

import * as utils from '../utils/utils.js';

export const updateEmotion = async (chatId, participantId, emotion) => {
    var emotionUrl = utils.backendUrl() + '/emotion';
    try {
        const response = await axios.post(emotionUrl, {
            chat_id: chatId,
            participant_id: participantId,
            emotion: emotion,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data.emotion;
    } catch (err) {
        console.log(err.response);
    }
};
